import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as S from './styled'

const ActionPanel = ({ children, isVisible }) => (
    <S.ActionPanel
        data-testid="action-panel"
        className={classNames('md:!px-2 lg:!px-12', {
            active: isVisible,
        })}
    >
        <S.ActionPanelContent>{children}</S.ActionPanelContent>
    </S.ActionPanel>
)

ActionPanel.propTypes = {
    isVisible: PropTypes.bool.isRequired,
}

export default ActionPanel
